import React from "react";

function AssetTokSer() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                Asset Tokenization Services by Xeer Technology
              </h2>
              <p>
                At Xeer Technology, we empower businesses to transform their
                physical and digital assets into secure, tradeable tokens. Our
                asset tokenization services bridge the gap between traditional
                finance and blockchain, enabling transparency, liquidity, and
                broader investment opportunities across various asset classes.
              </p>
              {/* <p>
                There are generally two types of AI: Narrow or Weak AI, which is
                designed to perform specific tasks, and General or Strong AI,
                which possesses human-level intelligence and can handle a wide
                range of tasks.
              </p> */}
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AssetTokSer;
